// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-783d4df2] {\n  fill: #fff\n}\n.st120[data-v-783d4df2] {\n  fill: #88d0a0\n}\n.st121[data-v-783d4df2] {\n  fill: #58d19f\n}\n.st123[data-v-783d4df2] {\n  fill: #00ac5f\n}\n", ""]);
// Exports
module.exports = exports;
